import { create } from 'zustand';

export interface Provider {
  id: string;
  name: string;
  specialty: string;
  email: string;
  phone: string;
  city?: string;
  zipCode?: string;
  address?: string;
  joinDate: string;
  bbpFee: number;
  bookingEnabled: boolean;
  notes?: string;
  appointments: number;
  revenue: number;
}

type State = {
  providers: Provider[];
  setProviders: (p: Provider[]) => void;
  addProvider: (provider: Provider) => void;
  updateProvider: (provider: Provider) => void;
};

const initialProviders: Provider[] = [
  { id: 'keisha-b', name: 'Keisha B.', specialty: 'Tribal Braids Specialist', email: 'keisha.b@example.com', phone: '(212) 555-0101', city: 'New York', joinDate: '2024-01-15', bbpFee: 15, bookingEnabled: true, appointments: 18, revenue: 4320 },
  { id: 'musu-k', name: 'Musu K.', specialty: 'Knotless Expert', email: 'musu.k@example.com', phone: '(718) 555-0102', city: 'Brooklyn', joinDate: '2024-02-01', bbpFee: 15, bookingEnabled: true, appointments: 15, revenue: 3750 },
  { id: 'rita-s', name: 'Rita S.', specialty: 'Box Braids Specialist', email: 'rita.s@example.com', phone: '(718) 555-0103', city: 'Queens', joinDate: '2024-01-20', bbpFee: 15, bookingEnabled: true, appointments: 12, revenue: 2880 },
  { id: 'asha-n', name: 'Asha N.', specialty: 'Natural Styles', email: 'asha.n@example.com', phone: '(212) 555-0104', city: 'Manhattan', joinDate: '2024-03-05', bbpFee: 15, bookingEnabled: true, appointments: 9, revenue: 1530 },
  { id: 'maria-l', name: 'Maria L.', specialty: 'Weave Specialist', email: 'maria.l@example.com', phone: '(718) 555-0105', city: 'Bronx', joinDate: '2024-02-10', bbpFee: 15, bookingEnabled: true, appointments: 14, revenue: 3220 },
  { id: 'jasmine-w', name: 'Jasmine W.', specialty: 'Locs & Twists', email: 'jasmine.w@example.com', phone: '(718) 555-0106', city: 'Brooklyn', joinDate: '2024-01-25', bbpFee: 15, bookingEnabled: true, appointments: 11, revenue: 2640 },
  { id: 'tanya-p', name: 'Tanya P.', specialty: 'Protective Styles', email: 'tanya.p@example.com', phone: '(718) 555-0107', city: 'Queens', joinDate: '2024-03-01', bbpFee: 15, bookingEnabled: true, appointments: 8, revenue: 1920 },
  { id: 'nicole-h', name: 'Nicole H.', specialty: 'Braids & Extensions', email: 'nicole.h@example.com', phone: '(212) 555-0108', city: 'Manhattan', joinDate: '2024-02-15', bbpFee: 15, bookingEnabled: true, appointments: 13, revenue: 3120 },
];

export const useProvidersStore = create<State>((set: any) => ({
  providers: initialProviders,
  setProviders: (providers: Provider[]) => set({ providers }),
  addProvider: (provider: Provider) => set((state: State) => ({
    providers: [...state.providers, provider]
  })),
  updateProvider: (provider: Provider) => set((state: State) => ({
    providers: state.providers.map(p => p.id === provider.id ? provider : p)
  })),
}));

export default useProvidersStore;
